import { NewNotificationEvent, NOTIFICATION_EVENT } from '../actions/notifications';
import { Notification } from '../types';

const notificationsReducer = (state: Notification[] = [], action: NewNotificationEvent) => {
    switch (action.type) {
        case NOTIFICATION_EVENT: {
            if (state.length > 10) {
                // clear local state if list is too long
                return [].concat([action.payload]);
            }

            return state.concat([action.payload]);
        }
        default:
            return state;
    }
};

export default notificationsReducer;
